import React from 'react';
export class Form extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            pacoteSel: "1",
            eventoSel: [],
            accept: false
        };
        Object.keys(props.formData.info).forEach(key => { this.state[key] = "" });

    }

    componentDidMount() {
        if (this.props.initialState)
            this.setState(this.props.initialState);
    }

    render() {
        const { info, pacote, tipoEvento, evento, termo } = this.props.formData;
        const validar = this.validar();

        return (
            <form name="send" onSubmit={(e) => this.props.handleSubmit(e, this.state)}>
                <div id="info-container">
                    <h1>Suas informações</h1>
                    {Object.keys(info).map(elem => {
                        const infoObj = info[elem];
                        // Para enumerações
                        if ("enumeração" in infoObj) return (
                            <div id={`info-${elem}`} key={elem}>
                                <label>
                                    <span> {infoObj.placeholder} </span>
                                    <select name={elem} ref={elem} value={this.state[elem]}
                                        onChange={this.handleInput}>
                                        <option value="no">== Selecione ==</option>
                                        {infoObj["enumeração"].map(option => <option key={option}>{option}</option>)}
                                    </select>
                                </label>
                            </div>
                        );
                        // Campos comuns
                        else return (
                            <div id={`info-${elem}`} key={elem}>
                                <input name={elem} ref={elem}
                                    value={this.state[elem]}
                                    placeholder={infoObj.placeholder}
                                    onChange={this.handleInput} />
                            </div>
                        );
                    })}

                </div>
                <div id="pack-container">
                    <h1>Pacote</h1>
                    <ul>
                        {Object.keys(pacote).map(pc => {
                            // So escreve se a key for um número (índice) e se o pacote estiver #disponível
                            if (isNaN(pc) || !pacote[pc]["disponível"]) return "";
                            const esgotado = "vagas" in pacote[pc] && pacote[pc].vagasRestantes < 1;
                            return (<li key={pc}>
                                <label title={esgotado ? "Não há vagas disponíveis no momento" : ""} className={esgotado ? "esgotado" : ""}>
                                    <span className="title1"> {pacote[pc]["nome"]} (R$ {pacote[pc]["preço"]},00) </span>
                                    <span className="title2"> {pacote[pc]["descrição"]} </span>
                                    <input disabled={esgotado} value={pc} type="radio" name="pacoteSel" checked={this.state.pacoteSel === pc} onChange={this.handleInput} />
                                    <span className="checkmark"> </span> </label>
                            </li>);
                        })}
                    </ul>
                </div>
                {Object.keys(tipoEvento).filter(tipo => Object.keys(evento).map(e => evento[e].tipo).includes(tipo)).map(tipo => {
                    const selecionavel = tipoEvento[tipo]["selecionável"];
                    return (
                        <div id={`${tipo}-container`} key={tipo}>
                            <h1>{tipo}</h1>
                            <ul>
                                {Object.keys(evento).filter(ev => evento[ev].tipo === tipo).map(ev => {
                                    const esgotado = evento[ev].vagasRestantes < 1 && selecionavel;
                                    return (
                                        <li key={ev}>
                                            <label title={esgotado ? "Não há vagas disponíveis no momento" : ""} className={esgotado ? "esgotado" : ""}>
                                                <span className="title1"> {evento[ev]["título"]} </span>
                                                <span className="title2"> {evento[ev]["título2"]} ({evento[ev]["horário"]}) </span>
                                                {"link" in evento[ev] && evento[ev].link &&
                                                    <span title="Abrir detalhes" className="link" onClick={e => this.openWindow(evento[ev].link)}> </span>
                                                }
                                                {selecionavel && <div>
                                                    <input disabled={esgotado} type="checkbox" name="eventoSel" value={ev} onChange={this.handleInput} checked={this.state.eventoSel.includes(ev)} />
                                                    <span className="checkmark"> </span>
                                                </div>}
                                            </label>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                    );
                }
                )}
                <div id="conclusion-container">
                    <div id="terms-container">
                        <label onClick={e => this.openWindow(termo.link)}><input type="checkbox" name="accept" checked={this.state.accept} onChange={this.handleInput} />
                            Ao marcar esta caixa, você concorda com os nossos
                            <a href={termo.link}> Termos de Serviço</a>.
                            <span className="checkmark"> </span>
                        </label>
                        {validar.length ? <div id="errors-container">
                            {validar.map((elem, idx) => <span className="error" key={idx}>{elem}</span>)}</div> :
                            <div id="final-price-container"> <span className="title2">Preço total: </span> <span id="final-price" className="title1"> R$ {this.calcula()},00</span></div>}
                        <button className={validar.length ? "disabled" : ""} disabled={!!validar.length} type="submit"> Confirmar </button>
                    </div></div>
            </form>);
    }

    handleInput = (e) => {
        const handleEvento = (eventoSelTest) => {
            const evento = this.props.formData.evento;
            // Conflitos de eventos
            const newEventoSel = eventoSelTest.filter((value, index, self) => self.indexOf(value) === index);
            for (let i = 0; i < newEventoSel.length; i++) {
                const evento_i = evento[newEventoSel[i]];
                if (!evento_i) continue;
                for (let j = i + 1; j < newEventoSel.length; j++) {
                    const evento_j = evento[newEventoSel[j]];
                    if (!evento_j) continue;
                    if (evento_i.slot & evento_j.slot) {
                        newEventoSel[j] = undefined; // Remove o último elemento do conflito
                        alert(`Conflito de horário entre ${evento_i["tipo"]} "${evento_i["título"]}" e ${evento_j["tipo"]} "${evento_j["título"]}"`);
                    }
                }
            }
            return newEventoSel.filter(e => !!e).sort(); // Remove elementos undefined
        }
        var { name, value, type } = e.target;
        if (name === "eventoSel") {
            const eventoSelTest = this.state.eventoSel;
            if (eventoSelTest.includes(value))
                eventoSelTest.splice(eventoSelTest.indexOf(value), 1);
            else eventoSelTest.push(value);
            value = handleEvento(eventoSelTest);
        } else if (type === "checkbox")
            value = !this.state[name];

        this.setState({ [name]: value });
    }

    validarCPF = (cpf) => {
        const filtro = /^\d{3}.\d{3}.\d{3}-\d{2}$/i;
        if (!filtro.test(cpf))
            return false;
        cpf = cpf.replace(/[^\d]/g, "");
        if (cpf.length !== 11 || cpf === "00000000000" || cpf === "11111111111" ||
            cpf === "22222222222" || cpf === "33333333333" || cpf === "44444444444" ||
            cpf === "55555555555" || cpf === "66666666666" || cpf === "77777777777" ||
            cpf === "88888888888" || cpf === "99999999999")
            return false;
        let soma = 0;
        for (let i = 0; i < 9; i++)
            soma += parseInt(cpf.charAt(i)) * (10 - i);
        let resto = 11 - (soma % 11);
        if (resto === 10 || resto === 11)
            resto = 0;
        if (resto !== parseInt(cpf.charAt(9)))
            return false;
        soma = 0;
        for (let i = 0; i < 10; i++)
            soma += parseInt(cpf.charAt(i)) * (11 - i);
        resto = 11 - (soma % 11);
        if (resto === 10 || resto === 11)
            resto = 0;
        if (resto !== parseInt(cpf.charAt(10)))
            return false;
        return true;
    }

    corrigeCPF = (e) => {
        let cpf = e.target.value.replace(/[^\d]/g, "");
        if (cpf.length === 11) {
            cpf = cpf.slice(0, 3) + "." + cpf.slice(3, 6) + "." + cpf.slice(6, 9) + "-" + cpf.slice(9);
            this.setState({ cpf: cpf });
        }
    }

    validar = () => {
        let error = [];
        const { tipoEvento, evento, pacote, info } = this.props.formData;
        const { eventoSel, pacoteSel } = this.state;

        // Função para mudar cores em caso de falha de valor
        const classError = (name, errorBool) => {
            document.getElementsByName(name).forEach((elem) => elem.className = errorBool ? "errorInput" : "");
        }

        // Todos os elementos de $post que possuem "regex" salvos em $info devem ser testados
        Object.keys(info).forEach(elem => {
            if ("regex" in info[elem] && !this.state[elem].match(new RegExp(info[elem].regex.split("/")[1]))) {
                error.push(`Campo ${elem} inválido.`);
                classError(elem, true);
            } else
                classError(elem, false);
        })

        // Algum evento deve estar selecionado
        if (!eventoSel.length && (!("vazio" in pacote[pacoteSel]) || !pacote[pacoteSel]["vazio"]))
            error.push("Nenhuma atividade selecionada.");
        else
            // Teste do conteúdo dos pacotes
            Object.keys(tipoEvento).forEach(tipo => {
                const n = eventoSel.reduce((counter, ev) => (evento[ev].tipo === tipo ? ++counter : counter), 0);

                if (tipo in pacote[pacoteSel]["conteúdo"]) {
                    const constraint = pacote[pacoteSel]["conteúdo"][tipo];
                    if ("min" in constraint && constraint["min"] > n)
                        error.push(`Você deve escolher no mínimo ${constraint["min"]} atividade(s) do tipo ${tipo} para este pacote.`);
                    if ("max" in constraint && constraint["max"] < n)
                        error.push(`Você deve escolher no máximo ${constraint["max"]} atividade(s) do tipo ${tipo} para este pacote.`);
                } else if (n > 0) {
                    error.push(`Este pacote não inclui atividades do tipo ${tipo}.`);
                }
            });
        if (this.state.accept !== true)
            error.push("Você deve aceitar os termos antes de continuar.");

        // Especiais:
        return error;
    }

    calcula = () => {
        const { pacote, evento, tipoEvento } = this.props.formData;
        const { pacoteSel, eventoSel } = this.state;
        let preco = 0;

        // Preço dos pacotes
        preco += pacote[pacoteSel]["preço"];

        // Preço dos eventos
        eventoSel.forEach(elem => {
            preco += (pacoteSel === "0" ? tipoEvento[evento[elem]["tipo"]]["preço"][0] : tipoEvento[evento[elem]["tipo"]]["preço"][1]);
        });

        // Remove os valores de eventos já contidos no pacote (tag: min)
        Object.keys(pacote[pacoteSel]["conteúdo"]).forEach(key => {
            if ("min" in pacote[pacoteSel]["conteúdo"][key])
                preco -= pacote[pacoteSel]["conteúdo"][key]["min"] * (pacoteSel === "0" ? tipoEvento[key]["preço"][0] : tipoEvento[key]["preço"][1]);
        });

        return preco;
    }
    openWindow = (target) => {
        const options = {
            height: 450, // sets the height in pixels of the window.
            width: 600, // sets the width in pixels of the window.
            toolbar: 0, // determines whether a toolbar (includes the forward and back buttons) is displayed {1 (YES) or 0 (NO)}.
            scrollbars: 0, // determines whether scrollbars appear on the window {1 (YES) or 0 (NO)}.
            status: 0, // whether a status line appears at the bottom of the window {1 (YES) or 0 (NO)}.
            resizable: 1, // whether the window can be resized {1 (YES) or 0 (NO)}. Can also be overloaded using resizable.
            left: 0, // left position when the window appears.
            top: 0, // top position when the window appears.
            center: 0, // should we center the window? {1 (YES) or 0 (NO)}. overrides top and left
            createnew: 0, // should we create a new window for each occurance {1 (YES) or 0 (NO)}.
            location: 0, // determines whether the address bar is displayed {1 (YES) or 0 (NO)}.
            menubar: 0 // determines whether the menu bar is displayed {1 (YES) or 0 (NO)}.
        };
        const parameters = "location=" + options.location +
            ",menubar=" + options.menubar +
            ",height=" + options.height +
            ",width=" + options.width +
            ",toolbar=" + options.toolbar +
            ",scrollbars=" + options.scrollbars +
            ",status=" + options.status +
            ",resizable=" + options.resizable +
            ",left=" + options.left +
            ",screenX=" + options.left +
            ",top=" + options.top +
            ",screenY=" + options.top;

        // target url
        window.open(target, 'popup', parameters);
    }

}
